module.exports = __webpack_public_path__ + "img/4.987289c4.png";